import { BouLinkExternal } from '@upright/ui/common/generic/content/texts/bou-link';
import LinkIcon from './heroicons-link-solid-24.svg';

interface Props {
  href: string;
  sourceLinkName?: string;
}

export function InfoBoxLinkButton(props: Props) {
  return (
    <BouLinkExternal href={props.href} target="_blank" style={{ display: 'flex', alignItems: 'center', gap: '0.4em' }}>
      <LinkIcon style={{ height: '1.2em', width: '1.2em' }} />
      <span style={{ textDecoration: 'underline' }}>{props.sourceLinkName || 'Company report'}</span>
    </BouLinkExternal>
  );
}
